import type { AiAutocompletePlugin } from './aiAutocompletePluginType';
import { acceptSuggestionCommand, dismissSuggestionCommand } from './ui/components/commands';
import { createPlugin } from './ui/components/main';

export const aiAutocompletePlugin: AiAutocompletePlugin = ({ api }) => ({
	name: 'aiAutocomplete',
	commands: {
		acceptSuggestion: (params) => acceptSuggestionCommand(params),
		dismissSuggestion: () => dismissSuggestionCommand,
	},
	pmPlugins() {
		return [
			{
				name: 'aiAutocompletePlugin',
				plugin: () => createPlugin(api),
			},
		];
	},
});
